import { ICalibration } from '@models/calibrations/calibration';

/**
 * * Each Calibration is assigned a Record Status:
 *   * Proposed: `P`
 *   * Active:   `A`
 *   * Inactive: `I`
 *   * Rejected: `R`
 *
 *
 * * When a new Calibration is saved, the API will assign an initial status of `Proposed`, which will not update the status of
 * other Calibration records.
 *
 * * If the status is updated from `Proposed` to `Active `, then the previous Active Calibration is set to `Inactive` and their related
 * regression data is deleted.
 *
 * * For a given Product:
 *   * only one record may be set to `Active` at any given time
 *   * only one record may be set to `Proposed` or `Rejected` at any given time
 *   * there may be several records with a status of `Inactive`
 */
export enum CalibrationStatus {
  Proposed = 'P',
  Active = 'A',
  Inactive = 'I',
  Rejected = 'R'
}

export enum ProductStatus {
  Active = 'A',
  Inactive = 'I',
  Deleted = 'D'
}

export enum MarketRateStatus {
  Active = 'A',
  Inactive = 'I',
  Deleted = 'D'
}

// export type CalibrationFilter = (c: IStableBalanceCalibration | IBetaCalibration | IDecayCalibration) => boolean;
export type CalibrationFilter = (c: ICalibration) => boolean;

// export const isProposedRejectedOrActive: CalibrationFilter = (c: IStableBalanceCalibration | IBetaCalibration | IDecayCalibration) =>
export const isProposedRejectedOrActive: CalibrationFilter = (c: ICalibration) =>
  c.RecordStatus === CalibrationStatus.Proposed ||
  c.RecordStatus === CalibrationStatus.Rejected ||
  c.RecordStatus === CalibrationStatus.Active;

export const isProposedOrActive: CalibrationFilter = (c: ICalibration) =>
  c.RecordStatus === CalibrationStatus.Proposed || c.RecordStatus === CalibrationStatus.Active;

export const isProposedOrRejected: CalibrationFilter = (c: ICalibration) =>
  c.RecordStatus === CalibrationStatus.Proposed || c.RecordStatus === CalibrationStatus.Rejected;

export const isActive: CalibrationFilter = (c: ICalibration) => c.RecordStatus === CalibrationStatus.Active;
